<template>
    <div></div>
</template>

<style scoped>
.div{ display: none; }
</style>

<script>
import $ from "jquery";
import { mapGetters, mapActions } from "vuex";

export default {
    async created() {
        await this.expire({ userId: this.sessionDetails.userId, sessionId: this.sessionDetails.sessionId });
        this.userClearStates();
        this.ncsClearStates();
        this.csClearStates();
        this.couponClearStates();

        $(document).ready(() => {
            localStorage.removeItem("vuex");
            setTimeout(() => {
                window.location.href = "/signin";
            }, 5);
        });
    },
    computed: {
        ...mapGetters({
            sessionDetails: 'user/session_details',
        })
    },
    methods: {
        ...mapActions({
            expire: 'user/expire',
            userClearStates: 'user/clearStates',
            ncsClearStates: 'ncs/clearStates',
            csClearStates: 'cs/clearStates',
            couponClearStates: 'coupon/clearStates'
        }),
    }
};
</script>
